import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  emptyPlaceholderMovementType: {
    id: 'jlBQV0',
    defaultMessage: 'Select Movement Indicator',
    description: 'Empty placeholder for movement type dropdown',
  },
  B2B: {
    id: 'xBG21k',
    defaultMessage: 'B2B',
    description: 'Business to Business movement type',
  },
  B2C: {
    id: 'AYmzm1',
    defaultMessage: 'B2C',
    description: 'Business to Customer movement type',
  },
  C2C: {
    id: 'xUpNaQ',
    defaultMessage: 'C2C',
    description: 'Customer to Customer movement type',
  },
  C2B: {
    id: 'eBH3YA',
    defaultMessage: 'C2B',
    description: 'Customer to Business movement type',
  },
});
